import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { Danger, Eye, EyeSlash } from 'iconsax-react'

import styles from './styles.module.css'

const Input = ({
  width,
  height,
  message,
  type,
  bgContainer,
  right,
  left,
  status,
  ...props
}) => {
  const InputRef = useRef()

  const [secured, setSecured] = useState(true)

  const getInputType = (status) => {
    switch (status) {
      case 'error':
        return 'error'

      case 'warning':
        return 'warning'

      case 'ok':
        return 'ok'

      default:
        return ''
    }
  }

  return (
    <div
      className={styles.content_container}
      onClick={() => InputRef.current.focus()}
    >
      <div
        style={{
          width,
          height,
          background: bgContainer
        }}
        className={`${styles.input_container}  ${getInputType(status)} shine_input`}
      >
        {right ? right : null}
        <input
          ref={InputRef}
          type={type == 'password' ? (secured ? 'password' : 'text') : type}
          {...props}
        />
        {type == 'password' &&
          (secured ? (
            <Eye
              className={styles.pass_toggle}
              onClick={() => setSecured(false)}
              size={20}
            />
          ) : (
            <EyeSlash
              className={styles.pass_toggle}
              onClick={() => setSecured(true)}
              size={20}
            />
          ))}
          {left ? left : null}
      </div>
    </div>
  )
}

Input.propTypes = {
  placeholder: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  right: PropTypes.object,
  left: PropTypes.object,
  status: PropTypes.oneOf(['ok', 'error', 'warning']),
}

Input.defaultProps = {
  placeholder: '',
  width: '100%',
  height: '48px',
}

export default Input
